// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__snHPx","content":"styles_content__jvJ9x","checkbox":"styles_checkbox__Ptifb","checkboxLabel":"styles_checkboxLabel__1GqwW"};